import Reward from "./Reward";

export default Reward